import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PanelGroupService {
  private colorSubject = new BehaviorSubject<string>('red'); // valor inicial
  public color$ = this.colorSubject.asObservable(); // $ indica que es un observable

  setColor(color: string) {
    this.colorSubject.next(color);
  }
}
